{
  "LOGIN": {
    "TITLE": "Logg inn i kontaktsenteret",
    "EMAIL": {
      "LABEL": "E-post",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Vennligst skriv inn en gyldig e-postadresse"
    },
    "PASSWORD": {
      "LABEL": "Passord",
      "PLACEHOLDER": "Passord"
    },
    "API": {
      "SUCCESS_MESSAGE": "Login successful",
      "ERROR_MESSAGE": "Could not connect to chat server. Please try again.",
      "UNAUTH": "Username or password is incorrect. Please try again.",
      "ACCOUNT_DEACTIVATED": "Kontoen din er deaktivert. Kontakt administratoren din.",
      "PASSWORD_LOGIN_DISABLED": "Innlogging med passord er deaktivert for kontoen din. Logg inn med OAuth (f.eks. Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Login with Google",
      "BUSINESS_ACCOUNTS_ONLY": "Please use your company email address to login",
      "NO_ACCOUNT_FOUND": "We couldn't find an account for your email address."
    },
    "FORGOT_PASSWORD": "Glemt passord?",
    "CREATE_NEW_ACCOUNT": "Opprett ny konto",
    "SUBMIT": "Logg inn"
  }
}
